// extracted by mini-css-extract-plugin
export default {"form":"form_form__boCOf"};